import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;

  .title {
    text-align: left;
    margin: 16px 0; 
  }

  .groups {
    max-width: 1000px;
    max-height: 200px;
    overflow-y: auto;

    .no-groups {
      font-family: ManropeLight, sans-serif;
      font-size: 13px;
      margin: 5px 0;
      font-style: italic;
      color: ${(props) => props.theme.colors.orange}
    }

    &::-webkit-scrollbar {
      width: 12px;
    }
  
    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.widget_background};
    }
  
    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.colors.inactive};
      border-radius: 20px;
      border: 3px solid ${(props) => props.theme.colors.inactive};
    }

    p {
      display: inline-block;
      height: 40px;
      padding: 10px 25px;
      margin: 5px;
      background: ${(props) => props.theme.colors.widget_background};
      border-radius: 6px;
      cursor: default;
      color: ${(props) => props.theme.colors.text};

      .group-name {
        max-width: 200px;
        height: 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      &:has(.delete-btn) {
        &:hover .delete-btn {
          opacity: 0.8;
        }
      }

      .delete-btn {
        float: right;
        left: 15px;
        top: -20px;
        position: relative;
        cursor: pointer;
        color: ${(props) => props.theme.colors.red};
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:has(.add-btn) {
        &:hover .add-btn {
          opacity: 0.8;
        }
      }

      .add-btn {
        float: right;
        left: 15px;
        top: -20px;
        position: relative;
        cursor: pointer;
        color: ${(props) => props.theme.colors.main_cta};
        opacity: 0;
        transition: opacity 0.3s;
      }
    }
  }

  .actions {
    display: block;
    margin-top: 16px;
    button {
      margin: 0 auto;
    }
  }
`;

const ErrorMessage = styled.p`
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  text-align: center;
  margin: 5px 0;
  color: ${(props) => props.theme.colors.red}
`;

export default { Wrapper, ErrorMessage };
